<template>
  <div style="width: 1440px;margin: 0 auto;">
    <headerTop></headerTop>
    <el-row style="background: #f6f6f8">
      <div style="width: 95%; margin: 10px auto">
        <el-form ref="form" :model="form" :rules="ruleValidate"  label-width="150px">
          <el-row>
            <el-col :span="12">
              <el-form-item label="询价标题:" prop="findSourceTitle" :rules="{
                required: true,
                message: '询价标题不能为空',
                trigger: 'blur',
              }">
                <el-input v-model="form.findSourceTitle" style="width: 370px" :disabled="disabled"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="项目名称:" prop="projectName" :rules="{
                required: true,
                message: '项目名称不能为空',
                trigger: 'blur',
              }">
                <el-input style="width: 370px" type="text" :disabled="true" v-model="form.projectName">
                  <el-button slot="append" icon="el-icon-search" @click="checkName(form.projectName)"></el-button>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="收货地址:" prop="addressVal" :rules="{
                required: false,
                message: '收货地址不能为空',
                trigger: 'blur',
              }">
                <el-cascader style="width: 370px" :disabled="disabled" v-model="addressVal" :options="options"
                  :props="{ expandTrigger: 'hover' }" @change="handleChange" clearable filterable placeholder="搜索">
                </el-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="收货人:" prop="username" :rules="{
                required: true,
                message: '收货人不能为空',
                trigger: 'blur',
              }">
                <el-input v-model="form.username" style="width: 370px" :disabled="disabled"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="收货人电话:" prop="phone" >
                <el-input v-model="form.phone" style="width: 370px" :disabled="disabled"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="详细地址:" prop="detail" :rules="{
                required: true,
                message: '详细地址不能为空',
                trigger: 'blur',
              }">
                <el-input v-model="form.detail" style="width: 370px" :disabled="disabled"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="预期回复日期:">
                <el-date-picker :disabled="disabled" v-model="form.expectDate" :picker-options="pickerOptions"
                  type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="请选择日期" style="width: 370px">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="需求日期:" prop="demandDate" :rules="{
                required: true,
                message: '需求日期不能为空',
                trigger: 'blur',
              }">
                <el-date-picker :disabled="disabled" v-model="form.demandDate" type="date" format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd" placeholder="请选择日期" :picker-options="pickerOptions" style="width: 370px">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="备注:">
                <el-input style="width: 370px" :disabled="disabled" type="textarea"
                  :autosize="{ minRows: 2, maxRows: 10 }" placeholder="请输入内容" v-model="form.remark">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="附件：" v-if="showFile">
            <el-table :data="yxAttachFileList" border stripe :show-header="false" style="width: 550px"
              v-if="yxAttachFileList.length > 0">
              <el-table-column prop="FileName" label="文件名称">
                <template slot-scope="scope">
                  <el-button size="small" type="text">
                    <a @click="linkDownload(scope.row.fileUrl)">{{
                      scope.row.fileName
                    }}</a>
                  </el-button>
                </template>
              </el-table-column>
              <el-table-column width="80px">
                <template slot-scope="scope">
                  <el-button size="small" type="text">
                    <a target="_blank" :href="scope.row.fileUrl">下载</a>
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
          <el-form-item style="margin: 0px -100px" v-if="!disabled">
            <el-upload :auto-upload="false" action="#" :file-list="[]" style="float: left" :on-change="handleChange1"
              :data="{ type: 1 }" multiple>
              <el-button type="success" size="small">Excel清单上传</el-button>
            </el-upload>
            <el-button type="primary" size="small" @click="addList()" style="margin-left: 30px">增加</el-button>
            <el-button type="danger" size="small" @click="deleteBatRow()" style="margin-left: 30px">批量删除</el-button>
            <el-button type="warning" @click="dowExcel()" size="small">下载模版</el-button>
          </el-form-item>
          <el-table :key="isUpdate" :data="detailList" style="width: 100%" stripe fixed
            @selection-change="handleSelectionChange" :header-cell-style="{
              background: '#EEEEEE',
              height: '50px',
              color: 'black',
              border: '1px solid #d3d3d3',
            }">
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column width="80" prop="lineCode" label="行号" header-align="center">
              <template slot-scope="scope">
                <el-input v-model="scope.row.lineCode" type="text" :disabled="disabled" />
              </template>
            </el-table-column>
            <el-table-column prop="requirementStoreName" label="清单商品名称" width="150" header-align="center">
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" :content="scope.row.requirementStoreName" placement="top-start">
                  <el-input v-model="scope.row.requirementStoreName" :disabled="disabled" type="text" />
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column prop="requirementStoreSpec" label="清单规格" width="150" header-align="center">
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" :content="scope.row.requirementStoreSpec" placement="top-start">
                  <el-input v-model="scope.row.requirementStoreSpec" :disabled="disabled" type="text" />
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column prop="demandCount" label="需求数量" width="150" header-align="center">
              <template slot-scope="scope">
                <!-- <el-input v-model="scope.row.demandCount" :disabled="disabled" type="text" /> -->
              <el-input-number v-model="scope.row.demandCount" @blur="inputNumBlur(scope.row,'demandCount')" :min="0" :step="1" :step-strictly="true" :controls="false" :disabled="disabled"/>

              </template>
            </el-table-column>
            <el-table-column prop="requirementStoreUnit" label="清单单位" width="100" header-align="center">
              <template slot-scope="scope">
                <el-input v-model="scope.row.requirementStoreUnit" :disabled="disabled" type="text" />
              </template>
            </el-table-column>
            <el-table-column prop="remark" label="备注" header-align="center" >
              <template slot-scope="scope">
                <el-input v-model="scope.row.remark" :disabled="disabled" type="text" />
              </template>
            </el-table-column>
            <el-table-column prop="productName" label="商品名称" header-align="center" :show-overflow-tooltip='true'>
            </el-table-column>
            <el-table-column prop="productCode" label="商品编码" header-align="center" :show-overflow-tooltip='true'>
            </el-table-column>
            <el-table-column prop="unitName" label="单位名称" header-align="center" :show-overflow-tooltip='true'>
            </el-table-column>
            <el-table-column prop="price" label="售价" header-align="center">
            </el-table-column>
            <el-table-column prop="itemSpecs" label="规格" header-align="center" :show-overflow-tooltip='true'>
            </el-table-column>
            <el-table-column prop="materialCode" label="物料编码" header-align="center" :show-overflow-tooltip='true'>
            </el-table-column>
            <el-table-column prop="materialName" label="物料名称" header-align="center" :show-overflow-tooltip='true'>
            </el-table-column>
            <el-table-column fixed="right" align="center" header-align="center" label="操作" width="210" v-if="!disabled">
              <template slot-scope="scope">
                <el-button @click="checkGoods(scope.row)" type="success" size="small">选择商品</el-button>
                <el-button type="danger" size="small" @click="delList(scope.$index, scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-form-item style="margin: 10px -100px">
            <el-upload class="upload-demo" :action="action" :headers="headers" :on-preview="handlePreview"
              :on-success="AttachOnSuccess" multiple :limit="8" :show-file-list="showlist">
              <el-button size="small" type="primary">上传附件</el-button>
            </el-upload>
            <el-table :data="newList" border stripe :show-header="false" style="width: 550px" v-if="newList.length > 0">
              <el-table-column prop="FileName" label="文件名称">
                <template slot-scope="scope">
                  <el-button size="small" type="text">
                    <a @click="linkDownload(scope.row.fileUrl)">{{
                      scope.row.fileName
                    }}</a>
                  </el-button>
                </template>
              </el-table-column>
              <el-table-column width="80px">
                <template slot-scope="scope">
                  <el-button size="small" type="text">
                    <a target="_blank" :href="scope.row.fileUrl">下载</a>
                  </el-button>
                </template>
              </el-table-column>
              <el-table-column width="80px">
                <template slot-scope="scope">
                  <el-button size="small" type="text" @click="deleteButton(scope.$index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
          <el-form-item style="margin-left: 30%; margin-top: 20px">
            <el-button type="primary" @click="onSubmit" v-if="!disabled">询价</el-button>
            <el-button type="success" @click="askPrice" v-if="disabled">询价</el-button>
          </el-form-item>
        </el-form>
      </div>
      <el-dialog title="" :visible.sync="dialogTableVisible" v-dialogDrag width="70%">
        <bpm :uItem="uItem" :dialogTableVisible="dialogTableVisible" @dialogRes="dialogRes" @beforeInit="beforeInit">
        </bpm>
      </el-dialog>
      <el-dialog title="项目列表" :visible.sync="dialogName">
        <names :nItem="nItem" :dialogName="dialogName" @namesRes="namesRes">
        </names>
      </el-dialog>
    </el-row>
  </div>
</template>
<script>
import { uploads } from "@/api/user.js";
import { getToken } from "@/axios/cookies.js";
import { getCityData } from "@/api/user.js";
import headerTop from "@/components/base/headerTop.vue";
import {
  saveFindSourcePrice,
  getFindSourcePriceInfo,
  getGoodsByCodeList
} from "@/api/noticedetail.js";
import bpm from "./bpm.vue";
import names from "./names.vue";
import { mapGetters } from "vuex";
export default {
  name: "notice",
  components: { bpm, names, headerTop },
  data() {
    return {
      showFile: false,
      yxAttachFileList: [],
      showlist: false,
      headers: {
        Authorization: getToken(),
        tenantId: "0000",
      },
      fileList: [],
      newList: [],
      action: uploads,
      disabled: false,
      lineCode: 1,
      isUpdate: true,
      options: null,
      uItem: null,
      ruleValidate: {
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
        // 手机号格式
          {
            required: true,
            pattern: /^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/,
            message: '请输入正确的手机号码',
            trigger: 'blur',
          },

        ]
      },
      form: {
        projcetSMcode: "",
        projcetSMuser: "",
        id: null,
        projectId: null,
        projectName: "",
        projectCode: "",
        address: {
          city: null,
          cityId: null,
          cityCode: null,
          districtCode: null,
          provinceCode: null,
          province: null,
          district: null,
        },
        // status: null,
        detail: null,
        businessUserId: "",
        businessUserName: "",
        expectDate: "",
        demandDate: "",
        remark: "",
        createUserType: "",
        findSourceTitle:"",
        username:"",
        phone:"",
        addressVal: [],
      },
      detailList: [],
      uid: null,
      rowData: {},
      dialogTableVisible: false,
      dialogName: false,
      nItem: null,
      addressVal: [],
      upList: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
    };
  },
  computed: {
    setLineCode() {
      if (this.detailList.length) {
        return (
          Math.max.apply(
            Math,
            this.detailList.map((item) => {
              return item.lineCode;
            })
          ) + 1
        );
      } else {
        return 1;
      }
    },
    ...mapGetters([
      "user", // 用户信息
      "uploadApi",
    ]),
  },
  watch: {
    options: {
      handler(nVal, oVal) {
        // console.log(nVal, oVal)
      },
      deep: true,
    },
  },
  async created() {
    await this.getCityList();
    if(this.$route.query.id){
      this.getDetail(this.$route.query.id);
    }
  },

  methods: {
    AttachOnSuccess(response, file, fileList) {
      let fileArray = {
        fileName: response.link[0].fileName,
        fileUrl: response.link[0].fileUrl,
      };
      if (this.newList == null) {
        this.newList = new Array();
        this.newList.push(fileArray);
      } else {
        this.newList.push(fileArray);
      }
    },
    deleteButton(index) {
      this.newList.splice(index, 1);
    },
    handleRemove(file, fileList) {
      this.newList = file;
    },
    handlePreview(file) {
      console.log(file);
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    checkUpList() {
      this.upList.forEach((item) => {
        item.lineCode = this.setLineCode;
        this.detailList.push(item);
      });
    },
    // 导入函数
    importfxx(obj) {
      let _this = this;
      // 通过DOM取文件数据
      this.file = obj;
      var rABS = false; // 是否将文件读取为二进制字符串
      var f = this.file;
      var reader = new FileReader();
      // if (!FileReader.prototype.readAsBinaryString) {
      FileReader.prototype.readAsBinaryString = function (f) {
        var binary = "";
        var rABS = false; // 是否将文件读取为二进制字符串
        var wb; // 读取完成的数据
        var outdata;
        var reader = new FileReader();
        reader.onload = async function (e) {
          var bytes = new Uint8Array(reader.result);
          var length = bytes.byteLength;
          for (var i = 0; i < length; i++) {
            binary += String.fromCharCode(bytes[i]);
          }
          var XLSX = require("xlsx");
          if (rABS) {
            wb = XLSX.read(btoa(fixdata(binary)), {
              // 手动转化
              type: "base64",
              cellDates: true,
            });
          } else {
            wb = XLSX.read(binary, {
              type: "binary",
              cellDates: true,
            });
          }
          outdata = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]);
          this.da = [...outdata];
          _this.lists = outdata;
          let lists = [];
          // 模版中的商品编码集合
          const storeCodeArr = []
          outdata.map((v) => {
            let obj = {};
            obj.requirementStoreName = v["商品名称"];
            obj.requirementStoreSpec = v["规格"];
            obj.requirementStoreUnit = v["清单单位"];
            obj.remark = v["备注"];
            obj.demandCount = !isNaN(parseFloat(v["需求数量"])) && isFinite(v["需求数量"]) ? v["需求数量"]:1;
            // (obj.demandCount = v["需求数量"]), 
            // 获取商品编码
            storeCodeArr.push(!isNaN(parseFloat(v["商品编码"])) && isFinite(v["商品编码"]) ? v["商品编码"]:null)
            lists.push(obj);
          });
          // 根据商品编码获取商品详情
          const resStore = await getGoodsByCodeList({uniqueList:storeCodeArr});
          if(resStore.code == 200){
            resStore.date.forEach((item,index)=>{
              if(item !== null){
                lists[index].productName = item.storeName; //商品名称
                lists[index].productCode = item.unique; //商品编码
                lists[index].unitName = item.unitName; //单位名称
                lists[index].cost = item.cost; //含税价格
                lists[index].price = item.price; // 售价
                lists[index].itemSpecs = item.sku; // 规格
                lists[index].materialCode = item.itemCode; //物料编码
                lists[index].materialName = item.itemName; //物料名称
              }
            })
            if(resStore.date.length == 0){
              this.$message({
                type: "warning",
                message: "未查询到相应商品信息，请手动选择！",
                duration: 10000
              });
            }
          }
          _this.upList = lists;
          _this.checkUpList();
        };
        reader.readAsArrayBuffer(f);
      };

      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
    },
    // 判断文件是否符合要求
    handleChange1(file, fileList) {
      console.log('上传文件');
      this.fileTemp = file.raw;
      if (this.fileTemp) {
          if (
          this.fileTemp.name.indexOf("xls") != -1 ||
          this.fileTemp.name.indexOf("xlsx") != -1
        ) {
          this.importfxx(this.fileTemp);
        } else {
          this.$message({
            type: "warning",
            message: "附件格式错误，请删除后重新上传！",
            duration: 10000,
          });
        }
      } else {
        this.$message({
          type: "warning",
          message: "请上传附件！",
          duration: 10000,
        });
      }
    },
    dowExcel() {
      let a = document.createElement("a");
      a.href = "../../../static/test1.xlsx";
      a.download = "项目清单模版.xlsx";
      a.style.display = "none";
      document.body.appendChild(a);
      a.click();
      a.remove();
    },

    excelData(res, header, filter, name) {
      require.ensure([], () => {
        const { export_json_to_excel } = require("../quickly/Export2Excel");
        const tHeader = header;
        const filterVal = filter;
        const list = res;
        const data = this.formatJson(filterVal, list);

        export_json_to_excel(tHeader, data, name);
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    handleSelectionChange(val) {
      console.log(val,'val');
      for (let i = 0; i < val.length; i++) {
        val[i].taxPrice = val[i].cost;
        val[i].sellingPrice = val[i].price;
      }
      this.askGoods = val;
    },
    getDetail(id) {
      getFindSourcePriceInfo({ id: id })
        .then((res) => {
          this.newList = res.yxAttachFileList;
          this.form.username = res.username;
          this.form.phone = res.phone;
          // this.form.status = res.status;
          // this.form.status = 1;
          this.form.demandDate = res.demandDate;
          this.form.expectDate = res.expectDate;
          this.form.address.city = res.city;
          this.form.address.cityId = res.cityId;
          this.form.address.province = res.province;
          this.form.address.cityCode = res.cityCode;
          this.form.address.district = res.district;
          this.form.address.provinceCode = res.provinceCode;
          this.form.address.districtCode = res.districtCode;
          this.containFreight = res.containFreight;
          this.form.projectName = res.projectName;
          this.form.projectCode = res.projectCode;
          this.form.projectId = res.projectId;
          this.form.detail = res.detail;
          // this.form.expiryDate = res.expiryDate;
          this.form.remark = res.remark;
          this.form.findSourceTitle = res.findSourceTitle
          this.form.findSourceCode = res.findSourceCode;
          // this.form.checkStatus = res.checkStatus;
          // this.detailList = res.infos;
          this.detailList.length = 0
          res.infos.forEach(item=>{
            this.detailList.push({
              lineCode:item.lineCode,
              remark:item.remark,
              status:0,
              requirementStoreName:item.requirementStoreName,
              requirementStoreSpec:item.requirementStoreSpec,
              demandCount:item.demandCount,
              requirementStoreUnit:item.requirementStoreUnit,
              noSellScope:null,
              isOrder:0
            })
          })

          this.form.id = res.id;
          this.handlerAddress(this.form.address);
        })
        .catch(() => { });
    },
    // 获取城市列表
    async getCityList() {
      var res = await getCityData();
      if (res.status === 200) {
        const json1 = JSON.parse(
          JSON.stringify(res.data).replace(/v/g, "value")
        );
        const json2 = JSON.parse(JSON.stringify(json1).replace(/n/g, "label"));
        const json3 = JSON.parse(
          JSON.stringify(json2).replace(/c/g, "children")
        );
        json3.forEach((i) => {
          i.children.forEach((j) => {
            j.children.forEach((k) => {
              delete k.children;
            });
          });
        });
        this.options = json3;
      } else {
        this.$message.warning(res.msg);
      }
    },
    beforeInit() {
      this.url = "/system/user/getBpmUser";
      this.params = {
        page: this.page,
        size: this.size,
      };
      const query = this.query;
      const type = query.type;
      const value = query.value;
      if (type && value) {
        this.params[type] = value;
      }
      return true;
    },
    dialogRes(a, data) {
      data.productName = a.spuName; //商品名称
      data.productCode = a.unique; //商品编码
      data.unitName = a.unitName; //单位名称
      // data.taxPrice = a.price; //含税价格
      data.price = a.price; // 售价
      data.cost = a.cost;
      data.itemSpecs = a.sku; // 规格
      data.materialCode = a.itemCode; //物料编码
      data.materialName = a.itemName; //物料名称
      // data.suppliersCode = a.supplierErpCode; //供应商编码
      // data.suppliersName = a.supplierLov; //供应商名称
      this.isUpdate = !this.isUpdate;
      this.dialogTableVisible = false;
    },
    namesRes(a) {
      this.form.projectSMuser = a.projectSMuser;
      this.form.projectSMcode = a.projectSMcode;

      this.form.projectName = a.projectName;
      this.form.projectId = a.id;
      this.form.projectCode = a.projectCode;
      this.form.deptId = a.deptId;
      this.form.deptName = a.deptName;
      this.dialogName = false;
    },
    checkGoods(data) {
      this.dialogTableVisible = true;
      this.uItem = data;
    },
    checkName(data) {
      this.dialogName = true;
      this.nItem = data;
    },
    async onSubmit() {

      //校验收货地址
      if(this.form.address.city === null){
        this.$message.warning("收货地址不能为空！");
        return;
      }
      let address = {};
      address.cityId = this.form.address.cityId;
      address.city = this.form.address.city;
      address.cityCode = this.form.address.cityCode;
      address.districtCode = this.form.address.districtCode;
      address.provinceCode = this.form.address.provinceCode;
      address.province = this.form.address.province;
      address.district = this.form.address.district;

      let para = {};
      para["fileList"] = this.newList;
      para["projcetSMuser"] = this.form.projectSMuser;
      para["projcetSMcode"] = this.form.projectSMcode;

      para["username"] = this.form.username;
      para["phone"] = this.form.phone;
      para["id"] = this.form.id;
      para["status"] = this.form.status;
      para['findSourceTitle'] = this.form.findSourceTitle
      para["address"] = address;
      para["deptId"] = this.form.deptId;
      para["deptName"] = this.form.deptName;
      para["remark"] = this.form.remark;
      para["expectDate"] = this.form.expectDate;
      para["demandDate"] = this.form.demandDate;
      para["detailList"] = this.detailList;
      para["projectName"] = this.form.projectName;
      para["projectId"] = this.form.projectId;
      para["projectCode"] = this.form.projectCode;
      para["detail"] = this.form.detail;
      para["type"] = 1;

      this.$refs.form.validate(async (seccess)=>{
        if(!seccess){
          //校验不通过
          return;
        }
        var res = await saveFindSourcePrice(para);
        if (res.code === 200) {
          this.$confirm("恭喜您，询价已提交成功！", "", {
            distinguishCancelAndClose: true,
            confirmButtonText: "查看询价单",
            cancelButtonText: "返回首页",
            type: "success",
            center: true,
          })
            .then(() => {
              this.$router.push({
                name: "myFindSource",
                // query: { id: this.form.id },
              });
            })
            .catch((action) => {
              this.$router.push(action === "cancel" ? "/" : "");
            });
        } else {
          this.$message.warning(res.msg);
        }
      })
    },
    //询价
    async askPrice() {
      let address =
        this.form.address.city +
        this.form.address.province +
        this.form.address.district;
      let para = {};
      para['fileList'] = this.newList
      para["inventoryId"] = this.$route.query.id;
      para["type"] = 2;
      para["address"] = address;
      para["remark"] = this.form.remark;
      para["expectDate"] = this.form.expectDate;
      para["demandDate"] = this.form.demandDate;
      para["detailList"] = this.askGoods;

      var res = await saveFindSourcePrice(para);
      if (res.code === 200) {
        this.$confirm("恭喜您，询价已提交成功！", "", {
          distinguishCancelAndClose: true,
          confirmButtonText: "查看询价单",
          cancelButtonText: "返回首页",
          type: "success",
          center: true,
        })
          .then(() => {
            this.$router.push({
              name: "goodHistory",
              query: { id: this.form.id },
            });
          })
          .catch((action) => {
            this.$router.push(action === "cancel" ? "/" : "");
          });
      } else {
        this.$message.warning(res.msg);
      }
    },
    addList() {
      var list = {
        lineCode: this.setLineCode,
        materialCode: "",
        materialName: "",
        storeId: "",
        price: "",
        remark: "",
        demandCount: null,
        requirementStoreUnit: "",
        productName: "",
        productCode: "",
        itemSpecs: "",
        unitCode: "",
        unitName: "",
        cost: "",
      };
      this.detailList.push(list);
    },
    delList(index, row) {
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "删除成功!",
          });

          this.detailList.splice(index, 1);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 选择省市区
    handleChange(val) {
      if (val.length) {
        this.options.forEach((i) => {
          if (i.value === val[0]) {
            this.form.address.province = i.label;
            this.form.address.provinceCode = i.childrenode;
            i.children.forEach((j) => {
              if (j.value === val[1]) {
                this.form.address.city = j.label;
                this.form.address.cityCode = j.childrenode;
                // this.form.address.cityId = j.value;
                j.children.forEach((k) => {
                  if (k.value === val[2]) {
                    this.form.address.district = k.label;
                    this.form.address.districtCode = k.childrenode;
                  }
                });
              }
            });
          }
        });
      } else {
        this.form.address = {
          city: null,
          province: null,
          district: null,
        };
      }
    },
    handlerAddress(val) {
      let addressVal = [];
      if (val) {
        this.options.forEach((i) => {
          if (i.label === val.province) {
            addressVal.push(i.value);
            i.children.forEach((j) => {
              if (j.label === val.city) {
                addressVal.push(j.value);
                j.children.forEach((k) => {
                  if (k.label === val.district) {
                    addressVal.push(k.value);
                  }
                });
              }
            });
          }
        });

        this.addressVal = addressVal;
      }
    },
    //inputNumber失去焦点后判断是否是数字
    inputNumBlur(row,type){
      if(!(!isNaN(parseFloat(row[type])) && isFinite(row[type]))){
        row[type] = 1
      }
    },
    // 批量删除
    deleteBatRow(){
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
          this.$message({
            type: "success",
            message: "删除成功!",
          });
          this.askGoods.forEach(row=>{
            const deIndex = this.detailList.findIndex(detal=> detal.lineCode == row.lineCode)
            this.detailList.splice(deIndex, 1);
          })
          
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    }
  },
};
</script>
<style lang="scss" scoped>
.el-input-number{
  width: 120px;
}
</style>



// WEBPACK FOOTER //
// src/views/addInventory/index.vue